/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react'
import Carousel from 'react-elastic-carousel'
import { Link, useHistory } from 'react-router-dom'
import MiniCart from '../../../components/common/DynamicComponents/MiniCart'
import store from '../../../redux/store'
import { myArrow, MobileArrowButtons } from '../../../components/common/DynamicComponents/CarouselComponents'
import PropTypes from 'prop-types'
import DummyImage from '../../../assets/images/productImg.jpg'
import { updateCartItems } from '../../../redux/actions/cartAction'
import { useSelector, useDispatch } from 'react-redux'
import { GetData, GetWithoutToken } from '../../../helpers/apiHandler'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import './FeaturedProducts.scss'

const FeaturedProducts = (props) => {
  const dispatch = useDispatch()
  const [data, setData] = useState([])
  const history = useHistory()
  const [toggleSidebar, setToggleSidebar] = useState(false)
  const locations = useSelector((state) => state.locations)
  const [locationId, setLocationId] = useState(null)
  const state = store.getState()
  const showSidebar = () => {
    setToggleSidebar(prevState => !prevState)
  }
  const cartItems = useSelector((state) => state.cart)

  useEffect(() => {
    if (locations.selectedLocation && !locations.loading) {
      setLocationId(locations.selectedLocation.id)
    }
  }, [locations])

  useEffect(() => {
    if (locationId) {
      getFeaturedProducts(locationId)
    }
  }, [locationId])

  const getFeaturedProducts = (locId) => {
    let url = 'customer/featuredProducts'

    if (locId) {
      url += `?customerLocationId=${locId}`
    }

    GetData(url).then((response) => {
      if (response.status === true) {
        setData(response.result)
      } else {
        history.push('/error-page')
      }
    }).catch(() => {
      history.push('/error-page')
    })
  }

  const carouselRef = useRef(null)

  const breakPoints = [
    {
      width: 1,
      itemsToShow: 1.4,
      pagination: true
    },
    {
      width: 450,
      itemsToShow: 2,
      pagination: true
    },
    {
      width: 650,
      itemsToShow: 3,
      pagination: true
    },
    {
      width: 950,
      itemsToShow: 5,
      pagination: true
    },
    {
      width: 1350,
      itemsToShow: 5,
      pagination: true
    }
  ]

  useEffect(() => {
    if (cartItems.loading === false) {
      if (state.auth.isAuthenticated) {
        if (sessionStorage.getItem('products') !== null) {
          handleCart(JSON.parse(sessionStorage.getItem('products'))[0])
          sessionStorage.removeItem('products')
        }
      }
    }
  }, [cartItems.loading])

  // function that handles the cart functionality
  function handleCart (item) {
    const prodIndex = cartItems.data.findIndex((prod) => prod.part_id === item.part_id)
    let productQuantity = 0

    if (prodIndex > -1) {
      productQuantity = cartItems.data[prodIndex].quantity + 1
    } else {
      productQuantity = 1
    }

    const part = {
      ...item,
      vendorId: 1,
      part_id: item.part_id,
      quantity: productQuantity,
      total: parseInt(productQuantity * item.sell_price)
    }

    dispatch(updateCartItems(part))
  }

  const handleLogoutCart = (product) => {
    // sessionStorage.setItem('products', JSON.stringify([product]))
    showSidebar()
  }

  return (
    <React.Fragment>
      { data?.products?.length > 0 && <>
      <MiniCart
            toggleSidebar={toggleSidebar}
            showSidebar={() => showSidebar()}
          />
      <div className="carousel__main__container">
        <div className="heading d-flex justify-content-between home-section__blog-container featured-products-heading">
          <span className="heading_featured">{data?.title}</span>
          <span className="slider_button_container d-block d-md-none">
          <MobileArrowButtons carousel={carouselRef} />
          </span>
        </div>
        <div className='position-relative mt-3'>
          {data && <Carousel
           renderPagination={({ pages, activePage, onClick }) => {
             return (
              <div className='d-flex mt-3' >
                {pages.map(page => {
                  const isActivePage = activePage === page
                  return (
                    <div
                    className={`d-flex rounded-circle mx-1 mx-lg-2 cursor-pointer ${isActivePage ? 'bg-danger' : ''}`}
                    style={{ height: '10px', width: '10px', border: '1px solid #645a5b' }}
                      key={page}
                      onClick={() => onClick(page)}
                      active={isActivePage}
                    />
                  )
                })}
              </div>
             )
           }}
            breakPoints={breakPoints}
            renderArrow={myArrow}
            showArrows={data?.products?.length > 5}
            itemPadding={[10, 5, 10, 10]}
            ref={carouselRef}
          >
            {data?.products.map((product, i) => {
              const productUrl = `/${product?.partCategory}/${product?.partSubCategory}/${product?.PartTerminologyName?.toLowerCase()
                .split(' ')
                .join('-')}-${product?.partNumber}?partId=${product?.part_id}`
              return (
                <div key={i} style={{ width: '100%' }}>
                  <div className="card home-page__product_card">
                    {product.comparePrice > product.price
                      ? (
                      <div className="home-page__product-card-header d-flex justify-content-between">
                        <div className="tag-badge tag-badge--theme sale-box">
                          Sale
                        </div>
                        <div>
                          {/* <LazyLoadImage effect="blur"
                            src="./image/expand.svg"
                            alt="Expand"
                            className="expand"
                          /> */}
                        </div>
                      </div>
                        )
                      : (
                      <div className="home-page__product-card-header">
                      </div>
                        )}
                    <Link to={productUrl} className="d-flex">
                      <div className='featured-image-container'>
                        <LazyLoadImage effect="blur"
                          className="mb-0 mx-auto"
                          src={product?.images[0] || DummyImage }
                          alt="Cardcap"
                          height="100%"
                          width="100%"
                        />
                      </div>
                    </Link>
                    <div className="card-body mt-0 p-0">
                    <Link to={productUrl}>
                      <div className="product-brand">{product.brandName}</div>
                      <div className="home-page__product-description my-1">
                        {product.PartTerminologyName}
                      </div>
                      </Link>
                      <div className="product__carticon d-flex justify-content-between">
                        {/* <div className="product-price mt-2">${product.price}</div> */}
                        <div className="product-price mt-2">
                          ${state.auth.isAuthenticated ? product.sell_price : '--'}{' '}
                        </div>
                        {state.auth.isAuthenticated
                          ? <div
                          className="d-flex align-items-center justify-content-center item-8"
                          onClick={() => handleCart(product)}
                        >
                          <div className="cart__icon__container new-cart-icon-hover">
                            <svg
                              width="20"
                              height="20"
                              className="new-cart-icon"
                            >
                              <circle cx="7" cy="17" r="2" />
                              <circle cx="15" cy="17" r="2" />
                              <path
                                d="M20,4.4V5l-1.8,6.3c-0.1,0.4-0.5,0.7-1,0.7H6.7c-0.4,0-0.8-0.3-1-0.7L3.3,3.9C3.1,3.3,2.6,3,2.1,3H0.4C0.2,3,0,2.8,0,2.6
V1.4C0,1.2,0.2,1,0.4,1h2.5c1,0,1.8,0.6,2.1,1.6L5.1,3l2.3,6.8c0,0.1,0.2,0.2,0.3,0.2h8.6c0.1,0,0.3-0.1,0.3-0.2l1.3-4.4
C17.9,5.2,17.7,5,17.5,5H9.4C9.2,5,9,4.8,9,4.6V3.4C9,3.2,9.2,3,9.4,3h9.2C19.4,3,20,3.6,20,4.4z"
                              />
                            </svg>
                          </div>
                        </div>
                          : <div
                          className="d-flex align-items-center justify-content-center item-8"
                          onClick={() => handleLogoutCart(product)}
                        >
                          <div className="cart__icon__container new-cart-icon-hover">
                            <svg
                              width="20"
                              height="20"
                              className="new-cart-icon"
                            >
                              <circle cx="7" cy="17" r="2" />
                              <circle cx="15" cy="17" r="2" />
                              <path
                                d="M20,4.4V5l-1.8,6.3c-0.1,0.4-0.5,0.7-1,0.7H6.7c-0.4,0-0.8-0.3-1-0.7L3.3,3.9C3.1,3.3,2.6,3,2.1,3H0.4C0.2,3,0,2.8,0,2.6
V1.4C0,1.2,0.2,1,0.4,1h2.5c1,0,1.8,0.6,2.1,1.6L5.1,3l2.3,6.8c0,0.1,0.2,0.2,0.3,0.2h8.6c0.1,0,0.3-0.1,0.3-0.2l1.3-4.4
C17.9,5.2,17.7,5,17.5,5H9.4C9.2,5,9,4.8,9,4.6V3.4C9,3.2,9.2,3,9.4,3h9.2C19.4,3,20,3.6,20,4.4z"
                              />
                            </svg>
                          </div>
                        </div> }
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </Carousel>}
        </div>
      </div>
      </>}
    </React.Fragment>
  )
}

FeaturedProducts.propTypes = {
  sectionData: PropTypes.any
}

export default FeaturedProducts
